import React from "react";
import Screenshot from "../imgs/fuaim.png";

export const Fuaim = () => {
  return (
    <div className="itemContainer">
      <div className="itemContained">
        <img
          src={Screenshot}
          alt="Fuaim"
          className="screenshot"

        />
      </div>
      <div
        className="itemContained itemExplainer"

      >
        <center>
          <span className="itemTitle">Fuaim</span>
          <br />
          <br />

          <span className="itemBody">
            A tool to practice pronunciation
          </span>
        </center>
      </div>
    </div>
  );
};
